import { render, staticRenderFns } from "./CreateAlokasi.vue?vue&type=template&id=17b4a704&scoped=true&"
import script from "./CreateAlokasi.vue?vue&type=script&lang=js&"
export * from "./CreateAlokasi.vue?vue&type=script&lang=js&"
import style0 from "./CreateAlokasi.vue?vue&type=style&index=0&id=17b4a704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b4a704",
  null
  
)

export default component.exports